var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      {
        staticStyle: {
          padding: "30px",
          background: "#ffffff",
          "box-shadow": "rgb(107 105 105 / 21%) 0px 0px 20px 0px",
          "border-radius": "10px"
        }
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "margin-bottom": "20px",
              width: "71px",
              height: "23px",
              "font-size": "24px",
              "font-family": "PingFang SC",
              "font-weight": "bold",
              color: "#343434"
            }
          },
          [_vm._v(_vm._s(_vm.$t("i18n_pick_up_party")))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btnBorder" }, [
          _c(
            "span",
            {
              staticClass: "pointer",
              staticStyle: {
                "font-size": "16px",
                "font-family": "PingFang SC",
                "font-weight": "500"
              },
              on: {
                click: function($event) {
                  _vm.dialogVisible = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_new_pickup_address")))]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          _vm._l(_vm.addrList, function(item, index) {
            return _c(
              "el-card",
              {
                key: index,
                staticClass: "box-card card-hover",
                staticStyle: {
                  "margin-bottom": "20px",
                  "border-radius": "10px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "max-height": "500px",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "space-between",
                      "padding-right": "40px"
                    }
                  },
                  [
                    _c("div", {}, [
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "20px",
                              "font-family": "PingFang SC",
                              "font-weight": "bold",
                              color: "#343434"
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "20px",
                              "font-size": "16px",
                              "font-family": "PingFang SC",
                              "font-weight": "500",
                              color: "#343434"
                            }
                          },
                          [_vm._v(_vm._s(item.tel))]
                        ),
                        _vm._v(" "),
                        item.isDefault
                          ? _c("div", { staticClass: "defaultAddrDiv" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("i18n_default_address")))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.tag
                          ? _c("div", { staticClass: "defaultAddrDiv" }, [
                              _c("span", [_vm._v(_vm._s(item.tag))])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "20px" } }, [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(item.country))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(item.city))]
                        ),
                        _vm._v(" "),
                        item.area
                          ? _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [_vm._v(_vm._s(item.area))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [_vm._v(_vm._s(item.address))]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      !item.isDefault
                        ? _c(
                            "span",
                            {
                              staticClass: "pointer editBtn",
                              on: {
                                click: function($event) {
                                  return _vm.setAsDefault(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_set_to_default")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pointer editBtn",
                          on: {
                            click: function($event) {
                              return _vm.edit(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "pointer",
                          staticStyle: { color: "#999", padding: "0 20px" },
                          on: {
                            click: function($event) {
                              return _vm.confirmDelete(item.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("i18n_delete")))]
                      )
                    ])
                  ]
                )
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticStyle: { "border-radius": "20px" },
            attrs: {
              "before-close": _vm.handleClose,
              "custom-class": "class1",
              title: _vm.$t("i18n_Create_new_address"),
              visible: _vm.dialogVisible,
              width: "30%"
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  width: "85%",
                  margin: "0 auto",
                  "max-width": "500px"
                }
              },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c("span", { staticStyle: { "line-height": "40px" } }, [
                          _vm._v(_vm._s(_vm.$t("i18n_contact_person")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("i18n_please_type_your_name")
                            },
                            model: {
                              value: _vm.submitForm.consignee,
                              callback: function($$v) {
                                _vm.$set(_vm.submitForm, "consignee", $$v)
                              },
                              expression: "submitForm.consignee"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c("span", { staticStyle: { "line-height": "40px" } }, [
                          _vm._v(_vm._s(_vm.$t("i18n_contact_info")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "i18n_please_type_the_contact_info"
                              )
                            },
                            model: {
                              value: _vm.submitForm.tel,
                              callback: function($$v) {
                                _vm.$set(_vm.submitForm, "tel", $$v)
                              },
                              expression: "submitForm.tel"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c("el-col", { attrs: { span: 7 } }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c("span", { staticStyle: { "line-height": "40px" } }, [
                          _vm._v(_vm._s(_vm.$t("i18n_contact_address")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 17 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c("el-cascader", {
                            attrs: {
                              options: _vm.citylist,
                              placeholder: _vm.$t("i18n_please_choose"),
                              clearable: "",
                              props: _vm.props
                            },
                            on: { change: _vm.handleChange },
                            model: {
                              value: _vm.value,
                              callback: function($$v) {
                                _vm.value = $$v
                              },
                              expression: "value"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c("div", {
                          staticStyle: {
                            "line-height": "40px",
                            width: "10px",
                            height: "10px"
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "2",
                              placeholder: _vm.$t(
                                "i18n_please_enter_the_detailed_location"
                              )
                            },
                            model: {
                              value: _vm.submitForm.address,
                              callback: function($$v) {
                                _vm.$set(_vm.submitForm, "address", $$v)
                              },
                              expression: "submitForm.address"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c("span", { staticStyle: { "line-height": "40px" } }, [
                          _vm._v(_vm._s(_vm.$t("i18n_label")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 18 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("i18n_please_enter") },
                            model: {
                              value: _vm.submitForm.label,
                              callback: function($$v) {
                                _vm.$set(_vm.submitForm, "label", $$v)
                              },
                              expression: "submitForm.label"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "300px",
                      margin: "0 auto",
                      "text-align": "center"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center"
                        }
                      },
                      [
                        _c("el-checkbox", {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { "text-color": "#5F4AFF" },
                          model: {
                            value: _vm.submitForm.isdefaultaddress,
                            callback: function($$v) {
                              _vm.$set(_vm.submitForm, "isdefaultaddress", $$v)
                            },
                            expression: "submitForm.isdefaultaddress"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "block",
                              "margin-bottom": "20px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("i18n_set_to_default_address")) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addAddr }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.submitForm.id
                              ? _vm.$t("i18n_edit")
                              : _vm.$t("i18n_add")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64a8d927", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a8d927","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/personalInfo/PickPage.vue
// module id = null
// module chunks = 